import React from "react";

const GelNailExtensionNearMeProcess = () => {
  return (
    <div className="hairSalonNearMeService">
      <h3>The Process of Getting Gel Nails Extensions at SCENT</h3>
      <p>
        Curious about what happens when you visit SCENT for gel nail extensions?
        Here’s a step-by-step guide to the process:
      </p>

      <li>
        <h6>1. Consultation</h6>
        <p>
          Your nail technician will discuss your preferences, assess the
          condition of your natural nails, and recommend the best options for
          your needs.
        </p>
      </li>
      <li>
        <h6> 2. Nail Preparation</h6>
        <p>
          The natural nails are cleaned, shaped, and lightly buffed to ensure a
          smooth base for the extensions.
        </p>
      </li>
      <li>
        <h6>3. Application of Gel Extensions</h6>
        <p>
          A nail form or tip is applied to create the desired length and shape.
          Layers of gel are then carefully applied and cured under a UV or LED
          lamp.
        </p>
      </li>
      <li>
        <h6> 4. Customization</h6>
        <p>
          {" "}
          Once the extensions are in place, you can choose your desired color,
          design, or nail art.
        </p>
      </li>
      <li>
        <h6> 5. Finishing Touches</h6>
        <p>
          A topcoat is applied for a glossy finish, and cuticle oil is used to
          nourish and hydrate the skin around your nails.
        </p>
      </li>
    </div>
  );
};

export default GelNailExtensionNearMeProcess;
